import { useState } from "react";
import { Card, Box, Typography, IconButton, Divider } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

// Reusable component for data rows
const DataItem = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" mt={1}>
    <Typography variant="body2" color="textSecondary">{label}</Typography>
    <Typography variant="body2">{value || "N/A"}</Typography>
  </Box>
);

const VehicleCard = ({ vehicleData }) => {
  const vehicles = vehicleData?.vehicles || [];
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const currentVehicle = vehicles[currentIndex];

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < vehicles.length - 1) setCurrentIndex(currentIndex + 1);
  };

  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: "10px",
        boxShadow: 3,
        padding: "1rem",
        textAlign: currentVehicle ? "left" : "center",
      }}
    >
      {/* No vehicles case */}
      {!currentVehicle ? (
        <Typography variant="h6" fontWeight="bold" color="error">
          No Vehicles Available
        </Typography>
      ) : (
        <>
          {/* Header Section */}
          <Box display="flex" alignItems="center">
            <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
              <ArrowBack />
            </IconButton>

            <Box ml={2} flexGrow={1}>
              <Typography variant="h6" fontWeight="bold">Vehicles</Typography>
              <Box display="flex" alignItems="center">
                <Typography
                  variant="body2"
                  color={currentVehicle.status === "active" ? "green" : "red"}
                >
                  {currentVehicle.status === "active" ? "Active" : "Inactive"}
                </Typography>
              </Box>
            </Box>

            <IconButton onClick={handleNext} disabled={currentIndex === vehicles.length - 1}>
              <ArrowForward />
            </IconButton>
          </Box>

          <Divider sx={{ my: 1 }} />

          {/* Vehicle Data Section */}
          <Box mt={2}>
            {/* <DataItem label="ID" value={currentVehicle.id} /> */}
            <DataItem label="Vehicle Type" value={currentVehicle.vehicleType} />
            <DataItem label="Vehicle Model" value={currentVehicle.vehicleModel} />
            {/* <DataItem label="Organization ID" value={currentVehicle.organizationId} /> */}
            {/* <DataItem label="Assigned To User" value={currentVehicle.assignedToUserId} /> */}
          </Box>

          {/* Vehicle Index Indicator */}
          <Box mt={2} textAlign="center">
            <Typography variant="body2">
              Vehicle {currentIndex + 1} of {vehicles.length}
            </Typography>
          </Box>
        </>
      )}
    </Card>
  );
};

export default VehicleCard;
